import API from '@services/API';
import axios from 'axios';
const path = `processos`;

const ProcessoService = {

  filtrar: async (filters) => await API.filters(path, filters),
  listar: async () => await API.list(path),
  listarUm: async (id) => await API.find(path, id),
  adicionar: async (arquivo,config) => await axios.post(path, arquivo, config),
 	editar: async (id, arquivo,config) => await axios.put(path + "/" + id, arquivo, config),
  excluir: async (id) => await API.remove(path, id),
  listarUf: async (id) => await API.list(`${path}/${id}/uf`),
  listarRegioes: async (id) => await API.list(`${path}/${id}/regioes`),
	listarTiposPendenciasTratamentoNome: async (id) => await API.list(`${path}/${id}/tiposPendenciasTratamentoNome`),
  listarTiposPendenciasTratamentoNota: async (id) => await API.list(`${path}/${id}/tiposPendenciasTratamentoNota`),
  listarTiposPendenciasTratamentoDataNascimento: async (id) => await API.list(`${path}/${id}/tiposPendenciasTratamentoDataNascimento`),
  listarTiposPendenciasTratamentoCPF: async (id) => await API.list(`${path}/${id}/tiposPendenciasTratamentoCpf`),
  listarStatusCartoes: async (id) => await API.list(`${path}/${id}/statusCartoes`),
	listarOrigensDosProblemasDeNome: async (id) => await API.list(`${path}/${id}/tratamentoNomes/origens`),
	downloadLogo: async (processo, arquivo) => await API.download(`processos/${processo}/logo`, arquivo),
	alertas: async (processo) => await API.get(`processos/${processo}/alertas`),
  buscarProcessoEmAndamento: async () => await API.list(`processos/emAndamento`),
  listarDocumentoEnvioCriterios: async (processo) => await API.list(`${path}/${processo}/documentoEnvioCriterios`),

}

export default ProcessoService;
